var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "v-toolbar",
        { attrs: { flat: "", dense: "" } },
        [
          _c("v-toolbar-title", [_vm._v("Generators")]),
          _c("v-divider", {
            staticClass: "mx-2",
            attrs: { inset: "", vertical: "" },
          }),
          _c(
            "v-btn",
            {
              staticClass: "ma-2",
              attrs: { small: "", color: "primary" },
              on: { click: _vm.row_create },
            },
            [_vm._v("ADD")]
          ),
          _c("v-spacer"),
        ],
        1
      ),
      _c(
        "v-expansion-panels",
        _vm._l(_vm.items, function (item, i) {
          return _c(
            "v-expansion-panel",
            { key: i },
            [
              _c("v-expansion-panel-header", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ open }) {
                        return [
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                "span",
                                { staticStyle: { "margin-top": "5px" } },
                                [_vm._v(_vm._s(item.name || "Generator: " + i))]
                              ),
                              _c("v-spacer"),
                              _c("v-fade-transition", [
                                open
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: { display: "inline-flex" },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mr-2",
                                            attrs: {
                                              small: "",
                                              color: "green darken-1",
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.row_copy(item)
                                              },
                                            },
                                          },
                                          [_vm._v("mdi-content-copy")]
                                        ),
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mr-2",
                                            attrs: {
                                              small: "",
                                              color: "red darken-1",
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.row_remove(item)
                                              },
                                            },
                                          },
                                          [_vm._v("mdi-delete")]
                                        ),
                                        _c("v-divider", {
                                          staticClass: "mx-1",
                                          attrs: { vertical: "" },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c(
                "v-expansion-panel-content",
                [
                  _c("r-reward-generator-model", {
                    attrs: { model: item, view_flags: _vm.view_flags },
                    on: {
                      "update:model": function ($event) {
                        item = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }